
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import documentExecutionSelectCNDialogDsecriptor from './DocumentExecutionSelectCNDialogDsecriptor.json'
import Listbox from 'primevue/listbox'

export default defineComponent({
    name: 'document-execution-select-cn-dialog',
    components: { Dialog, Listbox },
    props: {
        visible: { type: Boolean },
        crossNavigationDocuments: { type: Array }
    },
    emits: ['close', 'selected'],
    data() {
        return {
            documentExecutionSelectCNDialogDsecriptor
        }
    },
    methods: {
        closeDialog() {
            this.$emit('close')
        },
        navigationSelected(navigation: any) {
            this.$emit('selected', navigation)
        }
    }
})
